import React from "react";
import classes from "./signnew.module.css";

const Signnew = () => {
  return (
    <div className={classes.container}>
      <div className={classes.card}>
        {/* Left Panel */}
        <div className={classes.panel}>
          <h1>WELCOME</h1>
          <p>YOUR HEADLINE HERE</p>
          <p className={classes.description}>
            You can place subtext or a short description here to give users a brief idea of what this is about.
          </p>
        </div>

        {/* Right Login Panel */}
        <div className={classes.rightpanel}>
          <form className={classes.login}>
            <h2>Sign in</h2>
            <div className={classes.group}>
              <label>Email</label>
              <input type="email" placeholder="Enter your email" required />
            </div>
            <div className={classes.group}>
              <label>Password</label>
              <input type="password" placeholder="Enter your password" required />
            </div>
            <button type="submit" className={classes.loginbutton}>
              Sign in
            </button>
            <p className={classes.signuplink}>
              Don’t have an account? <a href="#">Sign up</a>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signnew